import $ from 'jquery';

export class Marker {
  public static get Width(): number { return 20; }
  public static get Height(): number { return 32; }

  public static get HalfWidth(): number { return this.Width / 2; }

  public static get Padding(): number { return 5; }
}

export class ZoomLevel {
  public static get World(): number { return 1; }
  public static get Continent(): number { return 5; }
  public static get State(): number { return 8; }
  public static get County(): number { return 10; }
  public static get City(): number { return 13; }
  public static get Streets(): number { return 15; }
  public static get Buildings(): number { return 20; }
}

export class Coordinates {
  public static toPixel(map: google.maps.Map, coordinate: google.maps.LatLng): google.maps.Point {
    let projection = map.getProjection();
    let topRight = projection.fromLatLngToPoint(map.getBounds().getNorthEast());
    let bottomLeft = projection.fromLatLngToPoint(map.getBounds().getSouthWest());
    let scale = Math.pow(2, map.getZoom());
    let worldPoint = projection.fromLatLngToPoint(coordinate);
    return new google.maps.Point(Math.floor((worldPoint.x - bottomLeft.x) * scale), Math.floor((worldPoint.y - topRight.y) * scale));
  }

  public static toLatLng(map: google.maps.Map, point: google.maps.Point): google.maps.LatLng {
    let projection = map.getProjection();
    let topRight = projection.fromLatLngToPoint(map.getBounds().getNorthEast());
    let bottomLeft = projection.fromLatLngToPoint(map.getBounds().getSouthWest());
    let scale = Math.pow(2, map.getZoom());
    let worldPoint = new google.maps.Point(point.x / scale + bottomLeft.x, point.y / scale + topRight.y);
    return projection.fromPointToLatLng(worldPoint);
  }
}
